export default __webpack_public_path__ + "static/media/tomcat-tool.961494a2.jfif";